module.exports = __webpack_public_path__ + "img/87_Gromovnic_Bucuresti_1795_foaie_de_titlu.f686f0ff.jpg";